import React, { useState } from "react";
import styled from "styled-components";
import Placeholder from "./Placeholder";

const Image = styled.img`
  width: 100%;
  height: auto;
`;

const ImageResponsive = ({ className, children, ...props }) => {
  const [isLoaded, setLoaded] = useState(false);

  const onLoad = () => {
    setLoaded(true);
  };

  return (
    <Placeholder aspectRatio={75} isLoaded={isLoaded} className={className}>
      <Image {...props} onLoad={onLoad} />
      {children}
    </Placeholder>
  );
};

export default ImageResponsive;
